import React from 'react';
import styled from 'styled-components';
import { FaRocket, FaUsers, FaHandshake, FaFlag } from 'react-icons/fa';

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  background-color: ${props => props.theme.colors.background};
  min-height: calc(100vh - 200px);
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const HeroSection = styled.div`
  background: linear-gradient(135deg, #8B5A96, #A569BD);
  color: white;
  padding: 4rem 2rem;
  border-radius: 20px;
  text-align: center;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    padding: 2.5rem 1.5rem;
    margin-bottom: 2rem;
  }
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
  font-family: 'Georgia', serif;
  font-weight: 700;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.2rem;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Section = styled.div`
  background-color: ${props => props.theme.colors.surface};
  border-radius: 10px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 10px ${props => props.theme.colors.shadow};
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const SectionTitle = styled.h2`
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const SectionContent = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  line-height: 1.6;
  font-size: 1.1rem;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
`;

const StatCard = styled.div`
  background: ${props => props.theme.colors.surface};
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 10px ${props => props.theme.colors.shadow};
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const StatIcon = styled.div`
  color: ${props => props.theme.colors.primary};
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const StatNumber = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: ${props => props.theme.colors.text};
  margin-bottom: 0.5rem;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const StatLabel = styled.div`
  color: ${props => props.theme.colors.textSecondary};
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const AboutUs = () => {
  return (
    <Container>
      <HeroSection>
        <HeroTitle>Hustling</HeroTitle>
        <HeroSubtitle>Empowering and connecting entrepreneurs in South Africa</HeroSubtitle>
      </HeroSection>

      <Section>
        <SectionTitle>
          <FaRocket />
          Our Vision
        </SectionTitle>
        <SectionContent>
          To build South Africa's most trusted community where entrepreneurs and hustlers connect, 
          collaborate, and grow. We aim to create an online, community-driven platform that empowers 
          entrepreneurs, startups, and innovators by giving them access to the tools they need to 
          build and scale their businesses. These tools will include everything from talent and skills — 
          at any level (partners, employees, consultants, assistants, etc.) — to funding, accounting 
          support, marketing assistance, legal services, and more.
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>
          <FaHandshake />
          Our Mission
        </SectionTitle>
        <SectionContent>
          Our mission is to connect entrepreneurs with the people and resources they need — starting 
          with skills, and expanding into funding, marketing, legal support, and beyond. South Africa's 
          entrepreneurial culture is rapidly growing, and we are here to support that growth by offering 
          a structured, credible platform where like-minded individuals can find each other, collaborate, 
          and thrive.
        </SectionContent>
      </Section>

    </Container>
  );
};

export default AboutUs;